/**
 * Created by lobin on 2019/1/21.
 */
import { request } from "../../plugins/axios";
const state = {
  jobList: [],
  pagination: {},
  sessionPagination: {},
  positionArea:[], //一级区域
  secondArea:[],   //二级区域
  thirdArea:[],    //三级区域
  hotJob:[],       //热门职位
  allJob:[],       //所有职位类型
  favoriteList:[],  //收藏的职位列表
  favoritePagination:{},
  cityCodeText:"",
  currentCityCode:null,

};
const getters = {};
const actions = {
  /**
   * 获取筛选出来的工作列表
   * @param data
   * @return {Promise.<void>}
   */
  async getJobs({commit}, data) {
    let datas = await request({
      url: "/portal/position",
      method: "POST",
      data
    });
    commit("setState", { key: "jobList", data: datas.data });
    if (datas.data) {
      commit("setState", { key: "pagination", data: datas.pagination });
    }
  },
  /**
   * 收藏的职位列表
   * @param data
   * @return {Promise.<void>}
   */
  async favorite({commit},params) {
    const {data,pagination} = await request({
      url: `/portal/position/favorites`,
      params
    });
    commit("setState", { key: "favoriteList", data: data });
    if (data) {
      commit("setState", { key: "favoritePagination", data: pagination });
    }
    
  },

  /**
   * 添加收藏职位
   * @param data
   * @return {Promise.<void>}
   */
  async deleteFavorite({}, id) {
    return await request({
      url: `/portal/position/favorites/${id}`,
      method: "DELETE"
    });
  },
  /**
   * 删除收藏职位
   * @param data
   * @return {Promise.<void>}
   */
  async addFavorite({}, id) {
    return await request({
      url: `/portal/position/favorites/${id}`,
      method: "POST"
    });
  },
  /**
   * 改变职位收藏状态
   * @param data
   * @return {Promise.<void>}
   */
  async changeFavoriteState({ commit }, index) {
    commit("setFavorite", { index: index });
  },
  /**
   * 获得职位详情
   * @param data
   * @return {Promise.<void>}
   */
  async getJobDetail({}, id) {
    const { data } = await request({
      url: `/portal/position/${id}?debug=true`
    });
    return data;
  },
  /**
   * 获取职位查询的一级城市
   * @param data
   * @return {Promise.<void>}
   */
  async getPositionArea({commit}) {
    const { data } = await request({
      url: `/portal/homeCity/all`
    });
    commit("setState", { key: "positionArea", data: data });
  },
   /**
   * 根据一级城市获取二级区域 --->后台管理的区域管理
   * @param data
   * @return {Promise.<void>}
   */
   async getSecondArea({commit}, id) {
    const { data } =  await request({
      url: `/portal/area/parent/${id}`,
    });
    
    commit("setState", { key: "secondArea", data:data[0].children });
  },

     /**
   * 根据二级城市获取三级区域  --->后台管理的园区管理
   * @param data
   * @return {Promise.<void>}
   */
    async getThirdArea({commit}, id) {
      const { data } =  await request({
        url: `/portal/park/${id}`,
      });
      commit("setState", { key: "thirdArea", data:data});
    },

   /**
   * 首页查询所有职位类型
   * @param data
   * @return {Promise.<void>}
   */
   async getAllJob({commit}) {
    const { data } = await request({
      url: `/portal/PositionType/getTreeAll`
    });
    let datas  = JSON.stringify(data).replaceAll(',"children":[]','')
    commit("setState", { key: "allJob", data: JSON.parse(datas) });
  },

    /**
   * 热门职位,
   * @param data
   * @return {Promise.<void>}
   */
    async getHotJob({commit}) {
      const { data } = await request({
        url: `/portal/hotPositionType/getAll`
      });
      commit("setState", { key: "hotJob", data: data });
    },
  /**
   * 申请职位投递在线简历
   * @param data
   * @return {Promise.<void>}
   */
  async sendOnlineResume({}, id) {
    return await request({
      url: `/portal/delivery/${id}/1?type=ONLINE`,
      method: "POST"
    });
  },
  /**
   * 申请职位投递附件简历
   * @param data
   * @return {Promise.<void>}
   */
  async sendAttachmentResume({}, data) {
    return await request({
      url: `/portal/delivery/${data.positionId}/1?type=ATTACHMENT&resumeId=${data.resumeId}`,
      method: "POST"
    });
  },
  /**
   * 获得专场招聘的列表
   * @param data
   * @return {Promise.<void>}
   */
  async getSpecialCompany({ commit }, params) {
    const { data, pagination } = await request({
      url: `/portal/companies`,
      params
    });
    if (data) {
      commit("setState", { key: "sessionPagination", data: pagination });
    }
    return data;
  },
  /**
   * 获得公司详情
   * @param data
   * @return {Promise.<void>}
   */
  // async getCompanyDetail({}, id) {
  //   const { data } = await request({
  //     url: `/portal/companies/${id}?debug=true`
  //   });
  //   return data;
  // },
  /**
   * 根据公司id查询该公司所有的职位发布列表
   * @param data
   * @return {Promise.<void>}
   */
  async getSessionPosition({}, data) {
    const res = await request({
      url: `/portal/position/company`,
      method: "put",
      data
    });
    return res;
  },
  // 张建点赞
  async giveThumbsUp({ }, data) {
    return request({
      url: `/portal/position/${data.id}/like`,
      method: "put",
      data: data
    });
  },
  //  张建取消点赞
  async unGiveThumbsUp({ }, data) {
    return request({
      url: `/portal/position/${data.id}/unLike`,
      method: "put",
      data: data
    });
  },
};
const mutations = {
  setState(state, { key, data }) {
    state[key] = data;
  },
  setFavorite(state, { index }) {
    state["jobList"][index]["favorite"] = !state["jobList"][index]["favorite"];
  },

};

export default {
  state,
  getters,
  actions,
  mutations
};
